import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-check",
  "use": "ico-check-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\" id=\"ico-check\">\n  <g id=\"ico-check_Rectangle_527\" data-name=\"Rectangle 527\" fill=\"#fff\" stroke=\"#9a9b9b\" stroke-width=\"1\">\n    <rect width=\"34\" height=\"34\" rx=\"5\" stroke=\"none\" />\n    <rect x=\"0.5\" y=\"0.5\" width=\"33\" height=\"33\" rx=\"4.5\" fill=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol